import { Toast } from "@/components/atoms/toast";
import BillingRecap from "@/components/templates/Checkout/components/billing-recap";
import CompleteCart from "@/components/templates/Checkout/components/complete-cart-button";
import DeliveryRecap from "@/components/templates/Checkout/components/delivery-recap";
import OrderRecap from "@/components/templates/Checkout/components/order-recap";
import { __ } from "@/lib/i18n/functions";
import { getCheckoutBackRoute } from "@/lib/utils";
import { ChevronLeft } from "lucide-react";
import Link from "next/link";

type RecapProps = {
  resolution: Resolution;
};

const Recap = ({ resolution }: RecapProps) => {
  const [route] = resolution.slugs;
  return (
    <article className="flex flex-3/5 flex-col gap-5">
      <Link
        href={getCheckoutBackRoute(resolution.locale, route)}
        className="text-blue-brand flex w-fit items-center gap-2.5 pr-1 font-medium transition-transform duration-150 ease-in-out active:scale-95 max-md:hidden"
      >
        <ChevronLeft size={24} aria-hidden="true" />
        {__("Return to the previous step", resolution.locale)}
      </Link>
      <Toast
        type="info"
        id="recap"
        title={__("Here's your order summary. Please confirm it so we can begin preparing it.", resolution.locale)}
        className="max-w-none shadow-none md:hidden"
      />
      <OrderRecap locale={resolution.locale} />
      <DeliveryRecap locale={resolution.locale} />
      <BillingRecap locale={resolution.locale} />
      <hr className="border-primary-light/30" />
      <section className="space-y-2.5">
        <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">
          {__("Payment with caution", resolution.locale)}
        </h2>
        <Toast
          type="info"
          id="recap"
          title={__(
            "A security deposit is required and varies depending on the rental amount. It is refunded (approximately 2–3 days) after the equipment is returned.",
            resolution.locale
          )}
          className="max-w-none shadow-none"
        />
      </section>
      <CompleteCart locale={resolution.locale} className="max-sm:hidden sm:ml-auto" />
    </article>
  );
};

export default Recap;
